<template>
<div>
    <div class="devices" v-if="builddata.length != 0">
      <div class="card-body">
        <div style="text-align:center;margin-bottom:1%">
          <v-avatar size="200" tile style="box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6);">
            <img
              class="elevation-5"
              :alt="$route.params.name"
              :src="builddata[0].logo"
            >
          </v-avatar>
        </div>
        <h5 class="card-title" style="text-align:center">{{ this.$route.params.name }}</h5>
        <v-divider></v-divider>
        <div v-if="builddata">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle><strong>Select Build Date : </strong></v-list-item-subtitle>
                <v-list-item-subtitle><label><v-select
                v-model="values" :items="builddate" item-text="builddate"  item-value="builddate" cache-items
                hide-no-data hide-details dark solo></v-select></label>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <div v-for="latestbuild in builddata" :key="latestbuild" class="latestbuild">
            <v-list-item v-if="latestbuild.build_date == values">
              <v-list-item-content>
                <v-list-item-subtitle><strong>Build Date : </strong>  
                  <i>{{ latestbuild.build_date }}</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>Device : </strong> 
                  <i v-if="latestbuild.device == 'RMX1971'">Realme 5 Pro</i>
                  <i v-if="latestbuild.device == 'r5x'">Realme 5 Series</i>
                  <i v-if="latestbuild.device == 'EVEN'">Realme C25 Series</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>By : </strong>  
                  <i><a :href="'/maintainer/'+latestbuild.maintainer">{{ latestbuild.maintainer }}</a></i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>Build tag : </strong>  
                  <i>{{ latestbuild.tag }}</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>Android Version : </strong>  
                  <i>{{ latestbuild.version }}</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="latestbuild.version != latestbuild.rom_version"><strong>Rom Version : </strong>  
                  <i>{{ latestbuild.rom_version }}</i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>Download : </strong> 
                  <i><a :href="latestbuild.download">{{ latestbuild.name }}</a></i>
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <i v-html="latestbuild.other_download_links"></i>
                </v-list-item-subtitle>
                <v-list-item-subtitle><strong>Changelog/Notes : </strong><p></p>
                  <i v-html="latestbuild.content"></i>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
        <div v-if="screenshots">
          <div v-for="screenshots1 in screenshots" :key="screenshots1" style="text-align:center">
            <v-carousel hide-delimiters>
              <div v-for="(item, i) in 15" :key="i">
                <div v-if="screenshots1['ss'+[i]]+'' != 'null' && i != 0">
                  <v-carousel-item >
                    <img :src="screenshots1['ss'+[i]]+''" style="width:16rem;">
                  </v-carousel-item>
                </div>
              </div>
            </v-carousel>
          </div>
        </div>
      </div>
    </div>
    <div class="devices1" v-if="loadingdata && builddata.length == 0">
        <v-progress-circular
        :rotate="180"
        :size="100"
        :width="15"
        :value="value"
        color="blue"
        >
        {{ value }}
        </v-progress-circular>
    </div>
    <div class="devices1" v-if="nodata">
        <img src="../assets/404.png" alt="404(Not Found)">
        <h1>404</h1>
        <p>No Data Found</p>
    </div>
</div>
</template>
<script>
import axios from 'axios';

  export default {
    name: 'RomsData',
    components: {
    },
    data: () => ({
        builddata: [],
        builddate: [],
        screenshots: [],
        loadingdata: false,
        nodata: false,
        values: null,
        interval: {},
        value: 10
    }),
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    },
    created () {
        this.getScreenshots();
        this.getbuilddata();
        this.latestdate();
    },
    watch: {
      '$route': 'getbuilddata'
    },

    methods: {
        getScreenshots() {
          let device = `?device=${this.$route.params.device}`
          let buildname = `buildname=${this.$route.params.name}`
          let android_version = `version=${this.$route.params.android_version}`
          let config = {
          method : 'get',
          url : `https://kharame-devices.herokuapp.com/getScreenshotsData${device}&&${buildname}&&${android_version}`,
          };
          axios(config)
          .then((response) => {
          if (response && response.data.message && response.data.status === 'S'){
            this.screenshots = response.data.message;
          }
          })
        },
        latestdate() {
          if (this.values == null) {
            this.values = this.builddata[0].build_date
          }
        },
        getbuilddata() {
            let device = `?device=${this.$route.params.device}`
            let buildname = `buildname=${this.$route.params.name}`
            let android_version = `version=${this.$route.params.android_version}`
            let maintainer = `maintainer=${this.$route.params.maintainer}`
            let config = {
                method : 'get',
                url : `https://kharame-devices.herokuapp.com/getBuildData${device}&&${buildname}&&${android_version}&&${maintainer}`,
            };
            this.loadingdata=true;
            axios(config)
            .then((response) => {
                if (response && response.data.message && response.data.status === 'S'){
                    this.builddata = response.data.message;
                }
                if (this.builddata) {
                    for (let i=0; i<this.builddata.length; i++) {
                     this.builddate.push(this.builddata[i].build_date)
                    }
                    this.loadingdata = false;
                } else {
                    setTimeout(() => { this.loadingdata = false; }, 2000);
                    setTimeout(() => { this.nodata = true; }, 2000);
                }
                if (this.builddata.length == 0) {
                  this.nodata = true
                }
                this.latestdate()
            })
        },
    },
  }
</script>
<style scoped>
.devices {
  margin-top:8%;
  margin-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  width:50%;
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6);
}
.devices1 {
  text-align: center;
  margin-top:8%;
  margin-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  width:85%;
}
.v-list-item__content .v-list-item__subtitle{
  color :whitesmoke !important;
  font-size: 14px;
  padding:1%;
}
.v-list-item__title, .v-list-item__subtitle{
  white-space: inherit;
}
>>>.ql-align-center {
    text-align : center;
}
>>>.ql-align-right {
    text-align : right;
}

@media (max-width: 1000px) {
  .devices {
    width: 75%;
    margin-top: 10%;
    margin-bottom: 5%;
  }
  .devices1 {
    margin-top: 10%;
    margin-bottom: 5%;
  }
}
@media (max-width: 550px) {
  .devices {
    width: 85%;
    display: block;
    margin-top: 18%;
    margin-bottom: 12%;
  }
  .devices1 {
    margin-top: 18%;
    margin-bottom: 12%;
  }
}
</style>